module.exports = __webpack_public_path__ + "images/da5e95b5ea0748751f4d0a6674232c8f.png";